import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import CardVersion2 from './CardVersion2';

import { getCurrentMeet } from 'selectors';

class CardsIndex extends Component {


  render() {
    const { meet } = this.props;

    const lifters = _.sortBy(meet.lifters, ['lot']);
    lifters.push({_id: 1});
    lifters.push({_id: 2});
    if(_.size(lifters) % 2 !== 0) {
      lifters.push({_id: 3});
    }

    return (
      <div className="cards-version2">
        <div className="print-note">Must be printed in portrait</div>
        {
          _.map(lifters, (lifter, index) => {
            return (
              <CardVersion2 meet={meet} lifter={lifter} index={index+1} key={lifter._id} />
            );
          })
        }
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    meet: getCurrentMeet(state, props)
  };
};

const actions = {};

export default connect(mapStateToProps, actions)(CardsIndex);
